module.exports = __webpack_public_path__ + "media/images/report-5097e89813f5ed73135ffb84e92faa86.svg";